// @flow
import React, { useState } from "react";
import classnames from "classnames";
import { Icon } from "semantic-ui-react";
import Styles from "./FoldableText.module.scss";

type Props = {
  title: string,
  content: string,
  className: ?string,
  relative?: boolean,
};

export default function FoldableText({ content, title, className, relative = false }: Props) {
  const [isVisible, setisVisible] = useState(false);
  const toggle = () => setisVisible((prevState) => !prevState);
  const iconClass = `${Styles.icon} ${isVisible ? Styles.iconOpen : ""}`;
  const contentClass = `${Styles.content} ${isVisible ? "" : Styles.hide}`;

  return (
    <div className={className}>
      <div onClick={toggle} className={Styles.titleWrapper}>
        <p>{title}</p>
        <Icon name={"chevron down"} className={iconClass} />
      </div>
      <p className={classnames(contentClass, { [Styles.isRelative]: relative })}>{content}</p>
    </div>
  );
}
